import React from 'react';
import { Link } from 'react-router-dom';
import Modal from '../Modal/Modal';
import styles from './SocialConnectionsModal.module.css';
import formatDisplayName from '../../utils/formatDisplayName';
import VerifiedBadge from '../VerifiedBadge/VerifiedBadge';

const SocialConnectionsModal = ({
	isOpen,
	title,
	users = [],
	onClose,
	currentUserID,
	currentFollowingIDs = new Set(),
	onToggleFollow,
	isUpdatingUserID = '',
}) => {
	if (!isOpen) {
		return null;
	}

	return (
		<Modal
			onClose={onClose}
			title={title}
			subtitle={`${users.length} ${users.length === 1 ? 'person' : 'people'}`}
			maxWidth={560}
		>
			{users.length === 0 ? (
				<p className={styles.EmptyText}>No users to show yet.</p>
			) : (
				<div className={styles.List}>
					{users.map((entry) => {
						const isCurrentUser = entry.userID === currentUserID;
						const isFollowing = currentFollowingIDs.has(entry.userID);
						const isLoading = isUpdatingUserID === entry.userID;

						return (
							<div className={styles.Row} key={entry.userID}>
								<Link to={`/profile/${entry.userID}`} className={styles.UserLink} onClick={onClose}>
									<img src={entry.profileImageLink} alt='' className={styles.Avatar} />
									<div className={styles.UserText}>
										<span className={styles.Username}>
											{formatDisplayName(entry.username)}
											<VerifiedBadge userPlan={entry.userPlan} totalXP={entry.totalXP} size='small' />
										</span>
										<span className={styles.UserID}>{entry.userID}</span>
									</div>
								</Link>

								{isCurrentUser ? (
									<span className={styles.YouBadge}>You</span>
								) : (
									<button
										type='button'
										className={`${styles.ActionBtn} ${isFollowing ? styles.Active : ''}`}
										onClick={() => onToggleFollow(entry)}
										disabled={isLoading}
									>
										{isLoading ? '...' : isFollowing ? 'Following' : 'Follow'}
									</button>
								)}
							</div>
						);
					})}
				</div>
			)}
		</Modal>
	);
};

export default SocialConnectionsModal;
